<template>
    <section class="LeadsAutoAssignerSettings">
        <el-form label-position="top" label-width="100px" @submit.native.prevent>

            <el-form-item label="Broker Lead Delay" prop="leads_broker_delay">
                <small class="d-block">
                    How long to wait since last assigning a lead to a broker before assigning them another lead.
                </small>
                <div>
                    <el-input-number v-model="leads_broker_delay" :min="0" :max="180" :step="5"></el-input-number>
                    <span class="ml-2">Minutes</span>
                </div>
            </el-form-item>

            <el-form-item label="Lead Count Strategy" prop="leads_count_type">
                <template slot="label">
                    Lead Count Strategy
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content="Auto lead assignment will attempt to distribute leads to brokers evenly based on how many leads they've already received."
                        placement="right"
                    >
                        <i class="el-icon-info info-icon"></i>
                    </el-tooltip>
                </template>

                <small class="d-block">
                    Choose the preferred method for counting the number of leads a broker has already been assigned.
                </small>
                <div>
                    <el-select v-model="leads_count_type" placeholder="Select" style="width: 400px; max-width: 100%">
                        <el-option v-for="e in options.leadCountTypes" :key="e.value" :label="e.label"
                                   :value="e.value"></el-option>
                    </el-select>
                </div>
            </el-form-item>

            <el-form-item label="Notification Timeout">
                <small class="d-block">
                    Set the timeout in minutes that you would like to be notified if there are no brokers that the auto
                    lead assignment can allocate to.
                </small>
                <el-input-number :min="1" v-model="leads_notification_timeout"></el-input-number>
            </el-form-item>

            <el-form-item label="Default Broker">
                <small class="d-block">
                    Assign deals from referrers to default broker
                </small>

                <el-checkbox v-model="leads_default_broker"></el-checkbox>
            </el-form-item>

            <el-form-item label="Default Broker">
                <small class="d-block">
                    Assign deals from existing customers to most recent broker
                </small>

                <el-checkbox v-model="leads_recent_broker"></el-checkbox>
            </el-form-item>

            <el-form-item label="Weekly Scheduler" prop="leads_weekly_schedule">
                <div slot="label">
                    Weekly Scheduler
                </div>

                <div class="d-flex justify-content-between align-items-end">
                    <small>
                        Schedule the auto assigner to only run during these times.
                    </small>
                </div>

                <SchedulePicker @change="updateSchedule" :value="leads_weekly_schedule" :dayRanges="options.dayRanges"/>
            </el-form-item>
        </el-form>
    </section>
</template>

<script>
import {mapState, mapActions, mapMutations} from "vuex"
import {required} from "vuelidate/lib/validators"
import {createHelpers} from "vuex-map-fields"
import moment from "moment"

import SchedulePicker from "@/components/LeadsAutoAssigner/shared/SchedulePicker"

import store from "./store"

const mapSettingsFields = createHelpers({
    getterType: "getSettingsField",
    mutationType: "updateSettingsField",
}).mapFields

export default {
    store,
    components: {
        SchedulePicker,
    },
    props: {},
    data() {
        return {
            timePickerFormat: "hh:mm A",
            hoursIncrement: 0.5,
            leadsState: []
        }
    },
    validations: {},
    computed: {
        ...mapState(["settings", "options"]),
        ...mapSettingsFields(["leads_broker_delay", "leads_count_type", "leads_weekly_schedule", "leads_notification_timeout", "leads_default_broker", "leads_recent_broker"]),
    },
    watch: {},
    mounted() {
        this.$store.dispatch("getSettings")
    },
    updated() {
    },
    activated() {
    },
    methods: {
        updateSchedule(schedule) {
            console.log("updateSchedule", schedule)
            this.$store.commit("updateSchedule", schedule)
        },
    },
}
</script>

<style lang="scss" scoped>

.info-icon {
    &:hover {
        cursor: pointer;
    }
}

.btn-schedule-add {
    &.absolute {
        position: absolute;
        top: 0;
        right: 0;
    }
}
</style>

<style lang="scss">
section.LeadsAutoAssignerSettings {
}
</style>
